interface IHeaderTextAnimationProps {
  text: string;
}
function HeaderTextAnimation(props: IHeaderTextAnimationProps) {
  return (
    <>
      <span
        style={{
          display: "flex",
          flexDirection: "row",
          transition:
            "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
        }}
      >
        {props.text == undefined
          ? ""
          : props.text.split("").map((char, charIndex) => {
              if (char != " ") {
                return (
                  <span
                    key={charIndex}
                    style={{
                      display: "inline-block",
                      opacity: 0,
                      transform: "translateX(-10px)",
                      animation: `fadeInMove 0.135s ease forwards ${
                        charIndex * 0.0225
                      }s`,
                    }}
                  >
                    {char}
                  </span>
                );
              } else return <div style={{ width: "5px" }} />;
            })}
      </span>
      {
        <style>
          {` 
            @keyframes fadeInMove { 
                to { 
                    opacity: 1; 
                    transform: translateX(0); 
                    } 
            } 
        `}
        </style>
      }
    </>
  );
}
export default HeaderTextAnimation;
